export var KEY = '---------';
/**
 * @returns {object}
 */

export default function separatorItem() {
  return {
    name: KEY
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_handsontable@8.4.0@handsontable/plugins/contextMenu/predefinedItems/separator.mjs
// module id = null
// module chunks = 